import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyBmNRy7pqEBuztNpghtsaWd5FmEVh5-S50",
    authDomain: "tenistapp2000.firebaseapp.com",
    projectId: "tenistapp2000",
    storageBucket: "tenistapp2000.appspot.com",
    messagingSenderId: "781308763515",
    appId: "1:781308763515:web:2aa074ae2881c2501e31de"
  }

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const auth = getAuth(app)

export {
    app,
    db,
    auth
}